import * as React from "react";
import { SVGProps } from "react";
export const HouseIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.76147 16.2385H7.11009V11.2477C7.11009 10.9982 7.1945 10.789 7.3633 10.6202C7.53211 10.4514 7.74128 10.367 7.99083 10.367H12.1009C12.3505 10.367 12.5596 10.4514 12.7284 10.6202C12.8972 10.789 12.9817 10.9982 12.9817 11.2477V16.2385H15.3303V7.72477L10.0459 3.76147L4.76147 7.72477V16.2385ZM3 15.945V7.72477C3 7.44997 3.06116 7.18962 3.18349 6.94373C3.30581 6.69786 3.48114 6.48522 3.70948 6.30581L8.99388 2.34251C9.32008 2.11417 9.67074 2 10.0459 2C10.421 2 10.7717 2.11417 11.0979 2.34251L16.3823 6.30581C16.6106 6.48522 16.7859 6.69786 16.9083 6.94373C17.0306 7.18962 17.0917 7.44997 17.0917 7.72477V15.945C17.0917 16.5101 16.8905 16.9939 16.4881 17.3963C16.0856 17.7988 15.6018 18 15.0367 18H12.1009C11.8514 18 11.6422 17.9156 11.4734 17.7468C11.3046 17.578 11.2202 17.3688 11.2202 17.1193V12.1284H8.87156V17.1193C8.87156 17.3688 8.78716 17.578 8.61835 17.7468C8.44954 17.9156 8.24037 18 7.99083 18H5.05505C4.48991 18 4.00612 17.7988 3.60367 17.3963C3.20122 16.9939 3 16.5101 3 15.945Z"
            fill="currentColor"
        />
    </svg>
);
HouseIcon.displayName = "HouseIcon";
